/* tslint:disable: ordered-imports*/
/* Modules */
import { CommonModule } from '@angular/common'
import { ModuleWithProviders, NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { AppCommonModule } from '@common/app-common.module'
import { AlertsService } from '@modules/alerts/services'
import { MessagesService } from '@modules/messages/services'
import { NgSelectModule } from '@ng-select/ng-select'

/* Components */
import * as navigationComponents from './components'

/* Containers */
import * as navigationContainers from './containers'

/* Guards */
import * as navigationGuards from './guards'

/* Layouts */
import * as appCommonLayouts from './layouts'

/* Services */
import * as navigationServices from './services'
import { NgxMaskPipe } from 'ngx-mask'

@NgModule({
    imports: [CommonModule, RouterModule, AppCommonModule, NgSelectModule, ReactiveFormsModule, FormsModule, NgxMaskPipe],
    declarations: [
        ...navigationContainers.containers,
        ...navigationComponents.components,
        ...appCommonLayouts.layouts
    ],
    exports: [
        ...navigationContainers.containers,
        ...navigationComponents.components,
        ...appCommonLayouts.layouts
    ],
    providers: [{ provide: 'window', useValue: window }]
})
export class NavigationModule {
    static forRoot(): ModuleWithProviders<NavigationModule> {
        return {
            ngModule: NavigationModule,
            providers: [
                ...navigationServices.services,
                ...navigationGuards.guards,
                AlertsService,
                MessagesService
            ]
        }
    }
}
